const topics = [
  { name: '国产剧', icon: 'ri-tv-line', count: '3.2万部', hot: true },
  { name: '韩剧', icon: 'ri-heart-line', count: '8,600部', hot: true },
  { name: '美剧', icon: 'ri-global-line', count: '1.5万部', hot: false },
  { name: '日剧', icon: 'ri-sun-line', count: '6,200部', hot: false },
  { name: '悬疑推理', icon: 'ri-search-eye-line', count: '1.8万部', hot: true },
  { name: '古装仙侠', icon: 'ri-moon-line', count: '9,400部', hot: false },
  { name: '甜宠爱情', icon: 'ri-heart-pulse-line', count: '1.2万部', hot: true },
  { name: '科幻大片', icon: 'ri-rocket-line', count: '5,700部', hot: false },
  { name: '动作冒险', icon: 'ri-speed-up-line', count: '1.1万部', hot: false },
  { name: '喜剧搞笑', icon: 'ri-emotion-laugh-line', count: '7,800部', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">分类浏览，找到您感兴趣的影视类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#index"
              className="group relative bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer text-center"
            >
              {topic.hot && (
                <span className="absolute top-2 right-2 w-2 h-2 rounded-full bg-accent-500"></span>
              )}
              <div className="w-10 h-10 mx-auto mb-2 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${topic.icon} text-lg text-accent-600`}></i>
              </div>
              <h3 className="font-label text-sm font-semibold text-foreground-900 mb-1">
                {topic.name}
              </h3>
              <span className="text-xs text-foreground-400">{topic.count}</span>
            </a>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#index"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-foreground-700 rounded-full text-sm font-medium border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部剧集分类
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}